import './overview-page.scss';
import { HeaderIngress } from '@components/overview/header-ingress/header-ingress';
import { MyChildren } from '@components/overview/my-children/my-children';
import { UsefulInfoLinkList } from '@components/overview/useful-info-link-list/useful-info-link-list';

export const OverviewPage = () => (
    <div className="overview-page">
        <HeaderIngress />
        <MyChildren />
        <UsefulInfoLinkList />
    </div>
);
